import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-88238c4c")
const _hoisted_1 = {
  id: "planning_page",
  class: "page minh0"
}
const _hoisted_2 = { class: "p-d-flex p-ai-center" }
const _hoisted_3 = {
  key: 0,
  class: "filters"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map p-mr-2 p-p-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map p-mr-2 p-p-2" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar p-mr-2 p-p-2" }, null, -1)
const _hoisted_7 = { class: "planning_section" }
const _hoisted_8 = { class: "list_section" }
const _hoisted_9 = { class: "p-d-flex p-flex-column p-p-0" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "p-d-flex p-flex-column p-pr-2 flex1" }
const _hoisted_12 = { class: "draggable_item__data" }
const _hoisted_13 = { class: "order_id" }
const _hoisted_14 = {
  key: 0,
  class: "client_code"
}
const _hoisted_15 = { class: "shift_name" }
const _hoisted_16 = { class: "customer_name" }
const _hoisted_17 = { class: "address" }
const _hoisted_18 = {
  key: 0,
  class: "other_orders"
}
const _hoisted_19 = {
  key: 1,
  class: "p-error"
}
const _hoisted_20 = {
  key: 0,
  class: "pi pi-align-justify draggable"
}
const _hoisted_21 = { style: {"height":"20px","margin-top":"auto"} }
const _hoisted_22 = {
  key: 1,
  class: "card no_orders_message"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", { class: "p-text-secondary" }, "Nessun ordine trovato", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, "Tornare alla pagina precedente e provare con altri parametri", -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "card map_section" }
const _hoisted_27 = {
  id: "map",
  ref: "mapEl"
}
const _hoisted_28 = { class: "p-grid" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "p-col" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Durata stimata:")
], -1)
const _hoisted_30 = { class: "p-col" }
const _hoisted_31 = { class: "p-grid" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "p-col" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Distanza:")
], -1)
const _hoisted_33 = { class: "p-col" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _component_ShiftToText = _resolveComponent("ShiftToText")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_OrderPriorityTimes = _resolveComponent("OrderPriorityTimes")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_PDialog = _resolveComponent("PDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BackButton, { to: _ctx.backRoute }, null, 8, ["to"]),
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('planning_taker.title')), 1)
      ]),
      (_ctx.orders)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.taker)
              ? (_openBlock(), _createBlock(_component_Chip, {
                  key: 0,
                  class: "p-mr-3"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createTextVNode(" " + _toDisplayString(_ctx.taker.name) + " " + _toDisplayString(_ctx.taker.surname), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.zone)
              ? (_openBlock(), _createBlock(_component_Chip, {
                  key: 1,
                  class: "p-mr-3"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _createTextVNode(" " + _toDisplayString(_ctx.zone.name), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.date)
              ? (_openBlock(), _createBlock(_component_Chip, {
                  key: 2,
                  class: "p-mr-3"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _createVNode(_component_DateFormatted, { date: _ctx.date }, null, 8, ["date"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.shift)
              ? (_openBlock(), _createBlock(_component_Chip, {
                  key: 3,
                  class: "p-mr-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ShiftToText, { shift: _ctx.shift }, null, 8, ["shift"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_ctx.isLoadingOrders)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_Skeleton),
              _createElementVNode("ul", _hoisted_9, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (i) => {
                  return _createVNode(_component_Skeleton, {
                    key: `loading_item_${i}`,
                    height: "8rem",
                    class: "p-mb-3"
                  })
                }), 64))
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.orders?.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_draggable, {
                      modelValue: _ctx.trackPoints,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.trackPoints = $event)),
                      "ghost-class": "ghost",
                      sort: true,
                      tag: "ul",
                      class: _normalizeClass(["order_list", { 'p-py-0 p-px-1': _ctx.readonly }]),
                      handle: ".draggable",
                      onEnd: _ctx.onEndSortTp,
                      disabled: _ctx.readonly
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_TransitionGroup, { name: "flip-list" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trackPoints, (t) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: _normalizeClass(["card draggable_item", {
                    'completed': _ctx.isTaskCompleted(t),
                    'canceled': _ctx.isTaskCanceled(t)
                  }]),
                                key: `${t.type}_${t.orderOnMap.orderId}`,
                                onClick: ($event: any) => (_ctx.onTpClick(t))
                              }, [
                                _createElementVNode("div", _hoisted_11, [
                                  _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass({
                          'ordinal_number': true,
                          'pickup': t.type === 'pickup',
                          'dropoff': t.type === 'dropoff',
                        })
                                    }, _toDisplayString(t.ordinalNumber), 3),
                                    _createElementVNode("span", _hoisted_13, [
                                      _createElementVNode("strong", null, "#" + _toDisplayString(t.orderOnMap.orderId), 1),
                                      (t.orderOnMap.order.external_client_code)
                                        ? (_openBlock(), _createElementBlock("strong", _hoisted_14, "- " + _toDisplayString(t.orderOnMap.order.external_client_code), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("span", _hoisted_15, [
                                      _createElementVNode("strong", null, _toDisplayString(t.orderOnMap.order.shift.name), 1)
                                    ]),
                                    _createVNode(_component_OrderPriorityTimes, {
                                      data: t.orderOnMap.order
                                    }, null, 8, ["data"])
                                  ]),
                                  _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("div", null, _toDisplayString(t.orderOnMap.order.customer.name), 1),
                                    _createElementVNode("div", null, _toDisplayString(t.orderOnMap.order.customer.surname), 1)
                                  ]),
                                  _createElementVNode("small", _hoisted_17, [
                                    (t.type === 'pickup')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(_toDisplayString(t.orderOnMap.order.pickup_full_address), 1)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(_toDisplayString(t.orderOnMap.order.dropoff_full_address), 1)
                                        ], 64))
                                  ]),
                                  (t.refs.length > 0)
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_18, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(t.refs, (tp) => {
                                          return (_openBlock(), _createBlock(_component_Badge, {
                                            key: `${tp.ordinalNumber}`
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("#" + _toDisplayString(tp.order.id), 1)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (!_ctx.checkPosition(t.orderOnMap.order.id))
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_19, "Consegna inserita prima del prelievo"))
                                    : _createCommentVNode("", true)
                                ]),
                                (!_ctx.readonly)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_10))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "class", "onEnd", "disabled"]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("small", null, "Ordini totali: " + _toDisplayString(_ctx.orders && _ctx.orders.length), 1)
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25))
            ], 64))
      ]),
      _createElementVNode("section", _hoisted_26, [
        (_ctx.orders?.length)
          ? (_openBlock(), _createBlock(_component_Toolbar, {
              key: 0,
              class: "p-mb-2"
            }, {
              start: _withCtx(() => [
                (!_ctx.readonly)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      icon: "pi pi-save",
                      label: "SALVA",
                      loading: _ctx.requestPending,
                      onClick: _ctx.onSave
                    }, null, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              end: _withCtx(() => [
                _createVNode(_component_Button, {
                  icon: "pi pi-eye",
                  label: "VISUALIZZA TRACCIATO",
                  onClick: _ctx.onPreviewClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_Skeleton, {
            height: "100%",
            width: "100%"
          })
        ], 512)
      ])
    ]),
    _createVNode(_component_PDialog, {
      header: "Dettaglio del percorso",
      position: "right",
      style: {"width":"25em"},
      visible: _ctx.showRouteDetails,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showRouteDetails = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.duration), 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.distanceKm), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}